exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.api-key-widget__label{font-style:italic;font-weight:300;font-size:10px;letter-spacing:1px;height:12px;margin-bottom:3px;margin-top:0}.api-key-widget__input,.api-key-widget__label{font-family:Open Sans,sans-serif;color:#8b8b8b}.api-key-widget__input{height:32px;width:calc(100% - 4px);background-color:#fff;border:1px solid #b8b8b8;border-radius:4px;font-weight:400;font-size:12px;text-indent:8px;line-height:32px;overflow:hidden}.api-key-widget__button{height:32px;width:128px;cursor:pointer;font-family:Open Sans,sans-serif;color:#fff;font-size:14px;font-weight:600;float:right;margin-top:16px;border-radius:5px}.api-key-widget__button--generate{background-color:#4bb543}.api-key-widget__button--regenerate{background-color:#d0021b;border-radius:4px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/APIKeyWidget/APIKeyWidget.scss
// module id = 1519
// module chunks = 0